import { useParams } from "@/components/hooks/use-params";
import { WebLayout } from "@/components/shared/layout/homepage";
import { BookingComplete } from "@/containers/booking-complete";
import type { ServiceName } from "@/types/service";

export const BookingCompletePage = () => {
  const { name } = useParams<{ name: ServiceName }>();
  if (!name) {
    return <div>404</div>;
  }
  return (
    <WebLayout>
      <BookingComplete />
    </WebLayout>
  );
};
